module.exports = "https://www.gc-pro.gnp.com.mx/562bcdcf30af0ca98a37c69470958bf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-21.jpg
// module id = 949
// module chunks = 0 1